import { render, staticRenderFns } from "./DestinationsSilo.vue?vue&type=template&id=1d4f32be&scoped=true&"
import script from "./DestinationsSilo.vue?vue&type=script&lang=js&"
export * from "./DestinationsSilo.vue?vue&type=script&lang=js&"
import style0 from "./DestinationsSilo.vue?vue&type=style&index=0&id=1d4f32be&lang=scss&scoped=true&rel=stylesheet%2Fscss&"
import style1 from "./DestinationsSilo.vue?vue&type=style&index=1&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f32be",
  null
  
)

export default component.exports